export const BACKGROUND_TAG_NAME = "background" as const;

export const BACKGROUND_EFFECTS = ["beams", "pattern"] as const;

export const BACKGROUND_DEFAULT_EFFECT = "beams" as const;

export const BACKGROUND_POSITIONS = ["absolute", "fixed"] as const;

export const BACKGROUND_FADES = ["none", "vertical", "radial"] as const;

export const BACKGROUND_DEFAULT_FADE = "none" as const;

export const BACKGROUND_DEFAULT_POSITION = "absolute" as const;

export const BEAMS_DEFAULT_COUNT = 24;

// One trip of a beam from bottom to top, before its own speed factor
export const BEAMS_DEFAULT_DURATION_MS = 9000;

export const BEAMS_DEFAULT_INTENSITY = 1;

export const BEAMS_DEFAULT_WIDTH = 1;

export const BACKGROUND_PATTERNS = [
  "dots",
  "grid",
  "dashed-grid",
  "hexagons",
] as const;

export const PATTERN_DEFAULT = "dots" as const;

export const PATTERN_DEFAULT_CELL_SIZE = 16;

export const PATTERN_DEFAULT_SPOTLIGHT_SIZE = 220;

// The pattern away from the spotlight, and under it
export const PATTERN_BASE_OPACITY = 0.35;

export const PATTERN_SPOTLIGHT_OPACITY = 1;

export const PATTERN_DEFAULT_REPEL_RADIUS = 140;

// Share of the radius a point right under the pointer is pushed by
export const PATTERN_DEFAULT_REPEL_STRENGTH = 0.35;
